import { Box, Center, Flex, Image } from "@chakra-ui/react";
import React from "react";
import catFooter from "../assets/images/footer_cat.svg";
import twitter from "../assets/images/simple-icons_x.svg";
import discord from "../assets/images/ic_baseline-discord.svg";
import telegram from "../assets/images/cib_telegram.svg";
import logoFooter from "../assets/images/footer_logo.svg";
import rCircle from "../assets/images/mynaui_letter-r-circle.svg";
import CustomText from "./CustomText";

const Footer = () => {
  return (
    <Center
      mt={{ base: "-40px", lg: "-135px" }}
      flexDirection={"column"}
      gap={"30px"}
    >
      <Image src={catFooter} alt="cat" w={"50%"} />
      <Flex align={"center"} gap={"20px"}>
        <Image
          src={twitter}
          alt="twitter"
          w={{ base: "40px", md: "58px", lg: "71px" }}
        />
        <Image
          src={discord}
          alt="discord"
          w={{ base: "40px", md: "58px", lg: "71px" }}
        />
        <Image
          src={telegram}
          alt="telegram"
          w={{ base: "40px", md: "58px", lg: "71px" }}
        />
      </Flex>
      <Box
        maxW={"1250px"}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        textAlign={"center"}
        px={{ base: "20px", lg: "70px" }}
        mt={{ lg: "34px" }}
      >
        <CustomText
          text="They might call Furry Silence a worthless meme coin with no team and no roadmap, but that’s just noise. We stay F*CKING UNFLAPPABLE while they can just f*ck off."
          size={{ base: "24px", lg: "36px" }}
          height="40.97px"
          color="#191919"
          align="center"
        />
      </Box>
      <Flex
        mt={{ base: "40px", lg: "107px" }}
        align={"center"}
        gap={{ base: "38px", lg: "88px" }}
        flexDirection={{ base: "column", lg: "row" }}
      >
        <CustomText
          text="WHITEPAPER"
          size={{ base: "24px", lg: "36px" }}
          height="40.97px"
          color="#191919"
          decoration="underline"
        />
        <CustomText
          text="hello@furrysilence.com"
          size={{ base: "24px", lg: "36px" }}
          height="40.97px"
          color="#191919"
          decoration="underline"
        />
        <CustomText
          text="SMART CONTRACT"
          size={{ base: "24px", lg: "36px" }}
          height="40.97px"
          color="#191919"
          decoration="underline"
        />
      </Flex>
      <Flex>
        <Image src={logoFooter} alt="logo" />
        <Image src={rCircle} alt="r" mt={"-90px"} ml={"-18px"} />
      </Flex>
    </Center>
  );
};

export default Footer;
